import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, input } from '@angular/core';
import { SkSpinner3Component } from '@rocksoft/cdk';

@Component({
  selector: 'ml-mdm-upload-spinner',
  templateUrl: './upload-spinner.component.html',
  styleUrls: ['./upload-spinner.component.scss'],
  animations: [
    trigger('control-animation', [
      state('true', style({})),
      state('false', style({})),
      transition('* => true', [
        style({
          opacity: 0,
        }),
        animate(500, style({ opacity: 1 })),
      ]),
      transition('* => false', [style({ opacity: 1 }), animate(500, style({ opacity: 0 }))]),
    ]),
    trigger('text-animation', [
      transition('void => left', [
        style({
          opacity: 0,
          transform: 'translate3d(-100%, 0, 0)',
        }),
        animate(500, style({ opacity: 1, transform: 'none' })),
      ]),
      transition('left => void', [
        style({ opacity: 1, transform: 'none' }),
        animate(500, style({ opacity: 0, transform: 'translate3d(100%, 0, 0)' })),
      ]),
      transition('void => right', [
        style({
          opacity: 0,
          transform: 'translate3d(100%, 0, 0)',
        }),
        animate(500, style({ opacity: 1, transform: 'none' })),
      ]),
      transition('right => void', [
        style({ opacity: 1, transform: 'none' }),
        animate(500, style({ opacity: 0, transform: 'translate3d(-100%, 0, 0)' })),
      ]),
      transition('void => up', [
        style({
          opacity: 0,
          transform: 'translate3d(0, 100%, 0)',
        }),
        animate(500, style({ opacity: 1, transform: 'none' })),
      ]),
      transition('up => void', [
        style({ opacity: 1, transform: 'none' }),
        animate(500, style({ opacity: 0, transform: 'translate3d(0, -100%, 0)' })),
      ]),
    ]),
  ],
  imports: [SkSpinner3Component],
})
export class UploadSpinnerComponent {
  readonly isLoading = input.required<boolean>();
  readonly status = input.required<string>();

  readonly small = input(false);
  readonly direction = input('up');
  readonly reverse = input(false);
}
